var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMindfull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--twemoji",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5C913B",
    d: "M.794 16.112c1 0 5.875 1.344 6.5 2.312L6.013 18.3s-3.906-1.25-4.906-1.25c-1.001 0-.313-.938-.313-.938z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#99AAB5",
    d: "M11 2c1 1 3 7 3 10s-2 6 2 8s5.001-1 5.001-5S20 7 19 5s-2 0-2 0s-1-4-2-4s-1 2-1 2s-2-2-3-2s0 1 0 1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD6DD",
    d: "M10 15c3 0 4 4 6 4s1-3 3-3s10-5 10-11s3-3 3-1c1 0 2 1.586 2 3c0 1 0 2-1 3c1 0 2 2 1 3c1 3-1 6-3 7c0 1-2 3-4 2c0 0-1 3-3 2c0 0 3.052 1.684 4 2c3 1 7 1 7 1s0 1-2 2c0 0 1 1 0 2s-2 1-2 1s1 2-2 1s-6-4-6-4s-5 1-9-1s-6-6-6-8s-3-1-4-1s2-2 3-2c0 0 0-2 3-2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#5C913B",
    d: "M6.95 18.019s5.438 2.625 7.938 6.656c1.9 3.064 2.782 8.656 2.782 8.656s.043.564-.907-2.281c-1-3-2.217-6.288-4.312-8.188c-3.344-3.031-4.75-3.5-6.062-4.25c-.332-.189.217-.687.561-.593z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#5C913B",
    d: "M16.198 28.54s2.038.103 3.107 2.139c1.068 2.036-.053 4.914-.053 4.914s-2.75-1.268-3.462-2.947c-.712-1.68.408-4.106.408-4.106zm-2.133-4.778s1.274 1.437 3.558 1.705c2.284.269 4.121-1.379 4.121-1.379s-2.144-1.97-3.968-2.033c-1.823-.065-3.711 1.707-3.711 1.707zm-4.047-3.148s-2.015.329-2.85 2.472s.425 4.01.425 4.01s2.534-.848 3.055-2.597c.521-1.747-.63-3.885-.63-3.885z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMindfull);
export default __webpack_public_path__ + "static/media/Mindfull.141b9b683b224b13846ee66a3c1217ed.svg";
export { ForwardRef as ReactComponent };